export default "__VITE_ASSET__BtDI$gRB__"